import { z } from 'zod';

export const RefMode = z.object({
  refModeID: z.number(),
  mode: z.string(),
});

export type RefMode = z.infer<typeof RefMode>;
